import lottie from 'lottie-web';
export const lottieAnimations = () => {

  // Helper function to get cookie value
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  // Helper function to set cookie
  const setCookie = (name, value, days = 365) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  };

  const lottieContainer = document.getElementById('lottie-intro-animation');
  const lottieContainerParent = document.getElementById('lottie-intro-container');

  // Check if animation has already been played (cookie exists)
  const animationPlayed = getCookie('STYXKEY_lottie-animation-played');

  if (animationPlayed) {
    // Animation already played, skip to completed state
    if (lottieContainerParent) {
      lottieContainerParent.remove();
    }
    return;
  }

  if (lottieContainer) {

    const animation = lottie.loadAnimation({
      container: lottieContainer, // The container element
      renderer: 'svg', // Render type: 'svg', 'canvas', or 'html'
      loop: false, // Set to false for one-time play
      autoplay: false, // Start automatically
      path: './wp-content/themes/era-partners-llc/lib/lottie/intro.json', // Path to the animation file
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid meet', // Covers the container while preserving aspect ratio
      },
    });

    // Set the playback speed (1 is normal speed, 2 is double speed, etc.)
    animation.setSpeed(0.75);

    document.body.classList.add('is-playing');

    setTimeout(() => {
      document.body.classList.add('is-scaling');
    }, 4250);

    setTimeout(() => {
      document.body.classList.add('is-played');
    }, 4750);

    setTimeout(() => {
      document.body.classList.add('is-removed');
    }, 5500);

    // Add a complete event listener
    animation.addEventListener('complete', () => {
      document.body.classList.add('is-removed');
      setCookie('STYXKEY_lottie-animation-played', 'true', 0.125);
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('is-played')) {
          // Element is in view, play the animation
          animation.play();
          entry.target.classList.add('is-played');
        }
      });
    }, {
      threshold: 0.8 // Trigger when 50% of the element is visible
    });

    observer.observe(lottieContainer);

  }
}